module.exports = __webpack_public_path__ + "img/pricing-shape.49dc89f3.png";